module.exports = __webpack_public_path__ + "fonts/regular.13fe778e.ttf";